import React, { useEffect, useState } from "react";
import { Button, Input, message, Modal, Popover, Table } from "antd";
import { useDeleteInput, useInputList } from "../../api/input";
import InputModal from "../modals/InputModal";
import { MoreOutlined } from "@ant-design/icons";
import { getStatusColor } from "../../util/statusColor";
import { useNavigate } from "react-router-dom";

type inputsTableProps = {
  searchText: string;
};

const InputsTable: React.FC<inputsTableProps> = ({ searchText }) => {
  const { data: inputs, isLoading, refetch } = useInputList(searchText);
  const [open, setOpen] = useState(false);
  const [selectedId, setSelectedId] = useState<string>("");
  const [tableData, setTableData] = useState<any[]>([]);

  const [search, setSearch] = useState<string>("");

  const navigate = useNavigate();

  const [deleteOpen, setdeleteOpen] = useState(false);
  const [deleteSelectedId, setdeleteSelectedId] = useState<string>("");

  const { mutateAsync: deleteInput, isPending } = useDeleteInput();

  useEffect(() => {
    if (search) {
      const _allData = inputs?.data?.data?.map((item: any) => {
        return {
          id: item.id,
          name: item.name,
          category: item.category,
          description: item.description,
          measurementUnit: item.measurementUnit,
        };
      });

      const _data = _allData.filter(
        (item: any) =>
          item.name?.toLowerCase().includes(search.toLowerCase()) ||
          item.category?.toLowerCase().includes(search.toLowerCase()) ||
          item.description?.toLowerCase().includes(search.toLowerCase()) ||
          item.measurementUnit?.toLowerCase().includes(search.toLowerCase()),
      );
      setTableData(_data);
    } else {
      if (
        inputs &&
        inputs.data &&
        inputs.data.data &&
        inputs.data.data.content
      ) {
        setTableData(inputs.data.data.content);
      }
    }
  }, [search, inputs]);

  useEffect(() => {
    if (searchText) {
      const _allData = inputs?.data?.data.map((item: any) => {
        return {
          id: item.id,
          name: item.name,
          category: item.category,
          measurementUnit: item.measurementUnit,
        };
      });

      const _data = _allData.filter(
        (item: any) =>
          item.name?.toLowerCase().includes(searchText.toLowerCase()) ||
          item.category?.toLowerCase().includes(searchText.toLowerCase()) ||
          item.measurementUnit
            ?.toLowerCase()
            .includes(searchText.toLowerCase()),
      );
      setTableData(_data);
    } else {
      if (inputs && inputs.data && inputs.data.data) {
        setTableData(inputs.data.data);
      }
    }
  }, [searchText, inputs]);

  const hideModal = () => {
    setOpen(false);
    setSelectedId("");
    refetch();
  };

  const inputsColumn = [
    {
      dataIndex: "name",
      title: "Name",
    },
    {
      dataIndex: "category",
      title: "Category",
    },
    {
      dataIndex: "measurementUnit",
      title: "Unit",
    },
    {
      title: "Actions",
      width: 200,
      render: (text: string, record: any, index: number) => (
        <div style={{ display: "flex", gap: 12 }}>
          <Button
            type="primary"
            onClick={() => {
              setSelectedId(record.id);
              setOpen(true);
            }}
          >
            Edit
          </Button>
          {/* <Button danger style={{ backgroundColor: '#f5222d'}} onClick={() => {
                        setdeleteSelectedId(record.id);
                        setdeleteOpen(true);
                    }}>Delete</Button> */}
        </div>
      ),
    },
  ];

  const onDelete = async () => {
    if (deleteSelectedId) {
      const result = await deleteInput(deleteSelectedId);

      if (result && result.status === 200) {
        message.success("Input deleted successfully");
      } else {
        message.error("Operation failed");
      }

      refetch();
    }
    setdeleteOpen(false);
  };

  return (
    <>
      <div className="hidden md:flex flex-col">
        <Modal
          title={<div style={{ color: "black" }}>Confirmation</div>}
          open={deleteOpen}
          centered
          onOk={onDelete}
          onCancel={() => setdeleteOpen(false)}
          closable
          style={{ color: "black" }}
        >
          Are you sure you want to delete this Input?
        </Modal>
        <InputModal open={open} selectedId={selectedId} hideModal={hideModal} />
        <Table
          dataSource={tableData}
          columns={inputsColumn}
          loading={isLoading}
        />
      </div>
      <div className="block md:hidden text-white sticky top-0">
        <Input
          onChange={(e) => setSearch(e.target.value)}
          placeholder="Search"
          style={{ backgroundColor: "#08453E", color: "white", height: 40 }}
        />
      </div>
      <div className="w-full grid grid-col divide-y-2 divide-green-400 md:hidden px-2 mb-4">
        {tableData.map((item: any) => (
          <div className="flex justify-between items-center py-2">
            <div className="flex flex-col gap-1 w-[95%]">
              <div className="flex gap-4 font-bold text-xl text-white">
                <div>{item.name}</div>
                <div>({item.measurementUnit})</div>
              </div>
              <div className="text-gray-300">{item.category} </div>
              <div style={{ color: getStatusColor(item.status) }} className="">
                {item.status}
              </div>
            </div>
            <Popover
              placement="bottomLeft"
              title={<div style={{ color: "black" }}>Actions</div>}
              content={
                <div style={{ color: "black", width: 200 }}>
                  <div
                    onClick={(e) => {
                      e.stopPropagation();
                      setSelectedId(item.id);
                      //   setSelectedStatus(item.status);
                      setOpen(true);
                    }}
                    style={{
                      display: "flex",
                      gap: 12,
                      alignItems: "center",
                      borderBottom: "1px solid #eee",
                      paddingBottom: 5,
                      marginTop: 15,
                      cursor: "pointer",
                    }}
                  >
                    <div>Edit</div>
                  </div>
                </div>
              }
            >
              <MoreOutlined className="text-white" />
            </Popover>
          </div>
        ))}
      </div>
    </>
  );
};

export default InputsTable;
